/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { SupportTicket } from './SupportTicket';
import {
    SupportTicketFromJSON,
    SupportTicketFromJSONTyped,
    SupportTicketToJSON,
    SupportTicketToJSONTyped,
} from './SupportTicket';

/**
 * 
 * @export
 * @interface ProfileSupportTicketsResponse
 */
export interface ProfileSupportTicketsResponse {
    /**
     * 
     * @type {Array<SupportTicket>}
     * @memberof ProfileSupportTicketsResponse
     */
    data: Array<SupportTicket>;
    /**
     * 
     * @type {Pagination}
     * @memberof ProfileSupportTicketsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ProfileSupportTicketsResponse interface.
 */
export function instanceOfProfileSupportTicketsResponse(value: object): value is ProfileSupportTicketsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ProfileSupportTicketsResponseFromJSON(json: any): ProfileSupportTicketsResponse {
    return ProfileSupportTicketsResponseFromJSONTyped(json, false);
}

export function ProfileSupportTicketsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSupportTicketsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SupportTicketFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function ProfileSupportTicketsResponseToJSON(json: any): ProfileSupportTicketsResponse {
    return ProfileSupportTicketsResponseToJSONTyped(json, false);
}

export function ProfileSupportTicketsResponseToJSONTyped(value?: ProfileSupportTicketsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SupportTicketToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

